import { useEffect, useState } from "react";
import { getAllIdiomas } from "../../../services/idioma.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { TITULO_IDIOMA_LIST } from "../../../utils/constantes";
import { IdiomaList } from "../../../modules/idioma/IdiomaList";

export const IdiomaPage = () => {
  const [busqueda, setBusqueda] = useState("");
  const [idiomas, setIdiomas] = useState(null);
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";

  useEffect(() => {
    obtenerIdiomas();
  }, []);

  const obtenerIdiomas = async () => {
    await getAllIdiomas()
      .then((idiomas) => setIdiomas(idiomas))
      .catch((err) => console.log(err));
  };

  return (
    <ContenedorPageTemplate objetos={idiomas} dirIcono={DIR_ICON_MAT} titulo={TITULO_IDIOMA_LIST}>
      <div className="fila flex gap-4 justify-between items-center mb-2 w-full">
        <div className="flex flex-col justify-end items-center">
          <p className="total">
            Total de idiomas: <span>{idiomas?.length}</span>
          </p>
        </div>
      </div>
      <IdiomaList idiomas={idiomas} onRefresh={obtenerIdiomas} />
    </ContenedorPageTemplate>
  );
};
